import { render, staticRenderFns } from "./m-upload.vue?vue&type=template&id=cc4015a4&scoped=true&"
import script from "./m-upload.vue?vue&type=script&lang=js&"
export * from "./m-upload.vue?vue&type=script&lang=js&"
import style0 from "./m-upload.vue?vue&type=style&index=0&id=cc4015a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4015a4",
  null
  
)

export default component.exports